import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import DefaultProfileTeaser from './Teaser';

import DefaultProfilePage from './Page';
import type { ProfileDefault } from '../../../types/uncinc_profile/profile';

interface DefaultProfileProps {
  entity: ImmutableEntity<ProfileDefault>;
  viewMode: string;
}

const NodeProfileWrapper: React.FC<DefaultProfileProps> = ({ entity, viewMode }) => {
  if (viewMode === 'teaser') {
    return <DefaultProfileTeaser entity={entity} />;
  }

  return <DefaultProfilePage entity={entity} />;
};

export default NodeProfileWrapper;
